const m = (e) => {
  const t = window.crypto.randomUUID();
  return e ? `${e}-${t}` : t;
}, w = async (e) => {
  const t = new TextEncoder().encode(e), n = await window.crypto.subtle.digest(
    "SHA-256",
    t
  ), r = String.fromCharCode(
    ...Array.from(new Uint8Array(n))
  );
  return window.btoa(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}, z = (e) => {
  const t = new URL(window.location.href), n = {};
  for (const r of e) {
    const o = t.searchParams.get(r);
    o && (n[r] = o);
  }
  return n;
};
var c = /* @__PURE__ */ ((e) => (e.ExchangeFailed = "EXCHANGE_FAILED", e.ExchangeFailedTokenError = "EXCHANGE_FAILED_TOKEN_ERROR", e.PkceAuthorizationFailed = "PKCE_AUTHORIZATION_FAILED", e.PkceAuthorizeResponseError = "PKCE_AUTHORIZE_FAILED_RESPONSE_ERROR", e.PersonaRedirectionError = "PERSONA_REDIRECTION_FAILED", e.PersonaUserInfoError = "PERSONA_PROFILE_ERROR", e.FirstPartyValidationError = "FIRST_PARTY_VALIDATION_ERROR", e.BreakoutTabError = "BREAKOUT_TAB_ERROR", e.PostMessageTimeout = "POST_MESSAGE_TIMEOUT", e.ValidationError = "VALIDATION_ERROR", e.RedirectLoginError = "REDIRECT_LOGIN_ERROR", e.RefreshTokenError = "REFRESH_TOKEN_ERROR", e.SilentLtiAuthError = "SILENT_LTI_AUTH_ERROR", e.BreakoutLtiAuthError = "BREAKOUT_LTI_AUTH_ERROR", e))(c || {});
class a extends Error {
  constructor(t, n, r) {
    super(n, { cause: r }), this.name = t;
  }
}
const _ = (e) => e !== null && typeof e == "object" && "error" in e && typeof e.error == "string" && "error_description" in e, C = (e) => e !== null && typeof e == "object" && "code" in e && "nonce" in e && "state" in e && "subject" in e && "type" in e && "message_id" in e, y = (e) => e !== null && typeof e == "object" && "code" in e && "nonce" in e && "state" in e, v = (e) => e !== null && typeof e == "object" && "access_token" in e && "refresh_token" in e && "token_type" in e && "expires_in" in e && "scope" in e, x = (e) => e !== null && typeof e == "object" && "guid" in e && "oauth" in e, U = (e) => e !== null && typeof e == "object" && "error" in e && "error_description" in e && "alias_nonce" in e, O = (e) => "ltiAuthNonce" in e && "ltiAuthorizeUrl" in e, I = "/4/authorize", F = "/4/oauth/tokens", H = "/4/oauth/userinfo", V = "/3/oauth/tokens", g = "alias-nonce-cache-key";
var k = /* @__PURE__ */ ((e) => (e.AUTHORIZATION_REQUEST = "authorization_request", e.AUTHORIZATION_RESPONSE = "authorization_response", e))(k || {}), T = /* @__PURE__ */ ((e) => (e.AUTHORIZATION_REQUEST = "com.talis.persona.AUTHORIZATION_REQUEST", e.AUTHORIZATION_RESPONSE = "com.talis.persona.AUTHORIZATION_RESPONSE", e))(T || {});
const f = (e) => {
  const { clientId: t, provider: n } = e, r = new URLSearchParams();
  return r.set("client_id", t), r.set("provider", n), r;
}, S = (e) => {
  const { redirectUri: t, codeChallenge: n, state: r, scope: o } = e, s = new URLSearchParams();
  s.set("code_challenge", n), s.set("code_challenge_method", "S256"), s.set("redirect_uri", t), s.set("response_type", "code"), s.set("state", r);
  const i = (o == null ? void 0 : o.split(" ")) ?? [], h = [
    .../* @__PURE__ */ new Set(["openid", "refresh_token", ...i])
  ].join(" ");
  return s.set("scope", h), s;
}, D = (e, t) => {
  const { personaOrigin: n } = e, { messageId: r } = t, o = f(e), s = S(t), i = new URLSearchParams([
    ...o,
    ...s
  ]);
  i.set("response_mode", "web_message"), i.set("message_id", r), i.set(
    "subject",
    T.AUTHORIZATION_REQUEST
  ), i.set(
    "type",
    k.AUTHORIZATION_REQUEST
  ), i.set("alias_nonce", t.aliasNonce);
  const h = new URL(I, n);
  return h.search = i.toString(), h;
}, N = (e, t) => {
  const { personaOrigin: n } = e;
  let r;
  O(t) ? r = new URL(t.ltiAuthorizeUrl) : r = new URL(I, n);
  const o = f(e), s = S(t), i = new URLSearchParams([
    ...o,
    ...s
  ]);
  return i.set("prompt", "none"), i.set("response_mode", "cors"), O(t) && i.set("lti_auth_nonce", t.ltiAuthNonce), r.search = i.toString(), r;
}, q = (e, t) => {
  const { personaOrigin: n } = e, r = f(e), o = S(t), s = new URLSearchParams([
    ...r,
    ...o
  ]), i = new URL(I, n);
  return i.search = s.toString(), i;
}, B = (e, t) => {
  const { personaOrigin: n } = e, { code: r, codeVerifier: o, nonce: s, redirectUri: i, state: h } = t, b = new URL(F, n), u = f(e);
  return u.set("code", r), u.set("code_verifier", o), u.set("grant_type", "authorization_code"), u.set("nonce", s), u.set("redirect_uri", i), u.set("state", h), { exchangeUrl: b, exchangeBody: u };
}, j = (e) => new URL(H, e), K = (e) => {
  const { personaOrigin: t, refreshToken: n, userGuid: r } = e, o = new URL(V, t), s = new URLSearchParams();
  return s.set("grant_type", "refresh_token"), s.set("client_id", r), s.set("refresh_token", n), { refreshTokenUrl: o, refreshTokenBody: s };
}, M = async (e) => {
  const { personaOrigin: t, accessToken: n } = e, r = j(t);
  try {
    const o = await fetch(r, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${n}`
      }
    }), s = await o.json();
    if (!o.ok)
      throw _(s) ? new a(
        c.PersonaUserInfoError,
        `Persona User Info Request: ${s.error_description}`
      ) : new a(
        c.PersonaUserInfoError,
        "Persona User Info Request: unexpected response status"
      );
    if (!x(s))
      throw new a(
        c.PersonaUserInfoError,
        "Persona User Info Request: invalid response"
      );
    return s;
  } catch (o) {
    throw o instanceof a ? o : new a(
      c.PersonaUserInfoError,
      "Persona User Info Request: unspecified error"
    );
  }
};
class d extends Error {
}
d.prototype.name = "InvalidTokenError";
function Z(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (t, n) => {
    let r = n.charCodeAt(0).toString(16).toUpperCase();
    return r.length < 2 && (r = "0" + r), "%" + r;
  }));
}
function $(e) {
  let t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return Z(t);
  } catch {
    return atob(t);
  }
}
function G(e, t) {
  if (typeof e != "string")
    throw new d("Invalid token specified: must be a string");
  t || (t = {});
  const n = t.header === !0 ? 0 : 1, r = e.split(".")[n];
  if (typeof r != "string")
    throw new d(`Invalid token specified: missing part #${n + 1}`);
  let o;
  try {
    o = $(r);
  } catch (s) {
    throw new d(`Invalid token specified: invalid base64 for part #${n + 1} (${s.message})`);
  }
  try {
    return JSON.parse(o);
  } catch (s) {
    throw new d(`Invalid token specified: invalid json for part #${n + 1} (${s.message})`);
  }
}
const Q = (e) => {
  const { active_pid: t } = G(e);
  return t;
}, X = (e, t, n) => ({
  ...e,
  code: t.code,
  codeVerifier: n,
  nonce: t.nonce
}), W = async (e, t) => {
  const { exchangeUrl: n, exchangeBody: r } = B(
    e,
    t
  );
  try {
    const o = await window.fetch(n, {
      method: "POST",
      body: r
    });
    if (!o.ok)
      throw new a(
        c.ExchangeFailedTokenError,
        "Unsuccessful response from token exchange"
      );
    const s = await o.json();
    if (!v(s))
      throw new a(
        c.ExchangeFailedTokenError,
        "Invalid response from token exchange"
      );
    return s;
  } catch (o) {
    throw o instanceof a ? o : new a(
      c.ExchangeFailed,
      "Unspecified error from token exchange"
    );
  }
}, R = async (e, t, n, r) => {
  const o = X(
    e,
    t,
    r
  ), s = await W(
    n,
    o
  ), i = await M({
    personaOrigin: n.personaOrigin,
    accessToken: s.access_token
  }), h = Q(
    s.access_token
  );
  return {
    access_token: s.access_token,
    refresh_token: s.refresh_token,
    active_pid: h,
    persona_guid: i.guid,
    persona_scopes: i.oauth.scopes,
    persona_profile: i.profile
  };
}, p = {
  get(e) {
    const t = sessionStorage.getItem(e);
    return t == null ? null : JSON.parse(t);
  },
  save(e, t) {
    sessionStorage.setItem(e, JSON.stringify(t));
  },
  remove(e) {
    sessionStorage.removeItem(e);
  }
}, Y = async (e) => {
  const { refreshTokenUrl: t, refreshTokenBody: n } = K(e);
  try {
    const r = await fetch(t, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: n
    }), o = await r.json();
    if (!r.ok)
      throw _(o) ? new a(
        c.RefreshTokenError,
        o.error_description
      ) : new a(
        c.RefreshTokenError,
        "Unexpected response from refresh token request"
      );
    if (!v(o))
      throw new a(
        c.RefreshTokenError,
        "Invalid response from refresh token request"
      );
    return o;
  } catch (r) {
    throw r instanceof a ? r : new a(
      c.RefreshTokenError,
      "Unspecified error from refresh token request"
    );
  }
}, J = (e, t) => {
  const { subject: n, type: r, messageId: o, state: s } = t;
  if (e.subject !== n)
    throw new a(
      c.ValidationError,
      "Invalid message subject"
    );
  if (e.type !== r)
    throw new a(
      c.ValidationError,
      "Invalid message type"
    );
  if (e.message_id !== o)
    throw new a(
      c.ValidationError,
      "Invalid message id"
    );
  if (e.state !== s)
    throw new a(
      c.ValidationError,
      "Invalid message state"
    );
}, L = (e, t) => {
  if (e.state !== t.state)
    throw new a(
      c.ValidationError,
      "Invalid state in PKCE response"
    );
}, ee = async (e, t) => {
  const n = N(
    e,
    t
  ), r = await te(n);
  return L(r, t), r;
}, te = async (e) => {
  try {
    const t = await window.fetch(e, {
      method: "GET",
      credentials: "include"
    }), n = await t.json();
    if (!t.ok)
      throw _(n) ? new a(
        c.PkceAuthorizeResponseError,
        n.error_description
      ) : new a(
        c.PkceAuthorizeResponseError,
        "Unexpected response from PKCE authorize credentials request"
      );
    if (!y(n))
      throw new a(
        c.PkceAuthorizeResponseError,
        "Invalid response from PKCE authorize credentials request"
      );
    return n;
  } catch (t) {
    throw t instanceof a ? t : new a(
      c.PkceAuthorizationFailed,
      "Unspecified error from PKCE authorize credentials request"
    );
  }
}, re = (e, t) => {
  const n = q(
    e,
    t
  );
  try {
    window.location.assign(n.toString());
  } catch (r) {
    throw r instanceof a ? r : new a(
      c.PersonaRedirectionError,
      "Unspecified error requesting redirection to Persona"
    );
  }
}, ne = () => new URL("/oauth/web_message", window.location.origin).toString(), l = (e, t) => ({
  clientId: e.clientId,
  provider: e.provider,
  messageId: m("message"),
  redirectUri: t ?? ne(),
  codeChallenge: m("challenge"),
  state: m("state")
}), fe = async (e) => {
  P();
  const t = l(e), n = await ee(
    e,
    t
  ), r = await w(
    t.codeChallenge
  );
  return R(
    t,
    n,
    e,
    r
  );
}, Re = (e, t, n) => {
  P();
  const r = l(e, t), o = {
    codeChallenge: r.codeChallenge,
    redirectUri: t,
    personaConfig: e,
    appState: n
  };
  p.save(r.state, o), re(e, r);
}, Ee = async () => {
  P();
  const { code: e, state: t, nonce: n } = z(["code", "state", "nonce"]), r = p.get(t ?? "");
  if (!t || !e || !n || !r)
    throw new a(
      c.RedirectLoginError,
      "Error completing redirect authentication with Persona"
    );
  p.remove(t);
  const o = await w(r.codeChallenge), s = l(
    r.personaConfig,
    r.redirectUri
  );
  return {
    loginData: await R(
      s,
      { code: e, state: t, nonce: n },
      r.personaConfig,
      o
    ),
    appState: r.appState
  };
}, P = () => {
  if (!(window.top === window.self))
    throw new a(
      c.FirstPartyValidationError,
      "Authentication method is only supported in first-party contexts."
    );
}, me = async (e) => Y(e), E = /* @__PURE__ */ new Map(), oe = (e, t) => {
  E.set(e, t);
}, se = (e) => E.get(e), ae = (e) => {
  E.delete(e);
}, ie = () => {
  E.clear();
}, A = {
  setItem: oe,
  getItem: se,
  removeItem: ae,
  clear: ie
}, ce = async (e, t) => {
  const n = N(
    e,
    t
  ), r = await he(n);
  return U(r) || L(r, t), r;
}, he = async (e) => {
  try {
    const t = await window.fetch(e, {
      method: "GET"
    }), n = await t.json();
    if (!t.ok && t.status === 404 && U(n))
      return n;
    if (!y(n))
      throw new a(
        c.PkceAuthorizeResponseError,
        "Invalid response from authorization request"
      );
    return n;
  } catch (t) {
    throw t instanceof a ? t : new a(
      c.PkceAuthorizationFailed,
      "Unspecified error from PKCE authorize credentials request"
    );
  }
}, ue = (e, t) => new Promise((n, r) => {
  const o = () => {
    window.removeEventListener("message", i);
  }, s = setTimeout(() => {
    window.removeEventListener("message", i), r(
      new a(
        c.PostMessageTimeout,
        "Timeout waiting for message"
      )
    );
  }, t), i = (h) => {
    h.origin === e && (clearTimeout(s), o(), n(h));
  };
  window.addEventListener("message", i);
}), de = async (e, t) => {
  const n = le(
    e,
    t
  );
  try {
    return await we(
      e,
      t
    );
  } finally {
    n.close();
  }
}, le = (e, t) => {
  const n = D(
    e,
    t
  ).toString(), r = window.open(n);
  if (!r)
    throw new a(
      c.BreakoutTabError,
      "Failed to open breakout tab"
    );
  return r;
}, we = async (e, t) => {
  const { personaOrigin: n, timeoutMilliseconds: r } = e, o = await ue(
    n,
    r
  );
  if (C(o.data)) {
    const s = {
      subject: T.AUTHORIZATION_RESPONSE,
      type: k.AUTHORIZATION_RESPONSE,
      messageId: t.messageId,
      state: t.state
    };
    return J(
      o.data,
      s
    ), o.data;
  } else
    throw new a(
      c.PkceAuthorizationFailed,
      "Unspecified error from PKCE authorize credentials request"
    );
}, ge = async (e) => {
  const { personaConfig: t, ltiAuthNonce: n, ltiAuthorizeUrl: r } = e, o = l(t), s = {
    ...o,
    ltiAuthNonce: n,
    ltiAuthorizeUrl: r
  }, i = await ce(
    t,
    s
  );
  if (U(i))
    throw A.setItem(g, i.alias_nonce), new a(
      c.SilentLtiAuthError,
      "No Persona user found for VLE alias, please try breakout login"
    );
  const h = await w(
    o.codeChallenge
  );
  return R(
    o,
    i,
    t,
    h
  );
}, pe = async (e) => {
  const t = A.getItem(g);
  if (!t)
    throw new a(
      c.BreakoutLtiAuthError,
      "Breakout auth called before silent auth attempt"
    );
  try {
    const n = l(e), r = {
      ...n,
      aliasNonce: t
    }, o = await de(
      e,
      r
    ), s = await w(
      n.codeChallenge
    );
    return R(
      n,
      o,
      e,
      s
    );
  } finally {
    A.removeItem(g);
  }
};
export {
  a as PersonaPadlockError,
  c as PersonaPadlockErrorType,
  ge as authenticateVleUserSilently,
  pe as authenticateVleUserViaBreakout,
  Ee as completeRedirectAuthentication,
  Re as initiateRedirectAuthentication,
  me as refreshAccessToken,
  fe as silentlyAuthenticate,
  P as validateIsFirstPartyContext
};
